export default __webpack_public_path__ + "static/media/14_1_0.d3d57a63.png";